var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShippedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 6.3751L4.6875 3.13135",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.5002V5.50018C13.1248 5.28098 13.0669 5.06569 12.9572 4.87591C12.8475 4.68613 12.6898 4.52853 12.5 4.41893L8.125 1.91893C7.93498 1.80922 7.71942 1.75146 7.5 1.75146C7.28058 1.75146 7.06502 1.80922 6.875 1.91893L2.5 4.41893C2.31016 4.52853 2.15249 4.68613 2.04279 4.87591C1.93309 5.06569 1.87522 5.28098 1.875 5.50018V10.5002C1.87522 10.7194 1.93309 10.9347 2.04279 11.1245C2.15249 11.3142 2.31016 11.4718 2.5 11.5814L6.875 14.0814C7.06502 14.1911 7.28058 14.2489 7.5 14.2489C7.71942 14.2489 7.93498 14.1911 8.125 14.0814L12.5 11.5814C12.6898 11.4718 12.8475 11.3142 12.9572 11.1245C13.0669 10.9347 13.1248 10.7194 13.125 10.5002Z",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04395 4.8501L7.5002 8.00635L12.9564 4.8501",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.3V8",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippedIcon);
export default __webpack_public_path__ + "static/media/shippedIcon.790ca82110f5ffa43a1f7248b3a72b0f.svg";
export { ForwardRef as ReactComponent };